// extracted by mini-css-extract-plugin
export var container = "footer-module--container--wjHmS";
export var linkHolder = "footer-module--linkHolder--Wy7lI";
export var logoLink = "footer-module--logoLink--j5-uB";